import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=559c4608&scoped=true&"
import script from "./artist.vue?vue&type=script&lang=ts&"
export * from "./artist.vue?vue&type=script&lang=ts&"
import style0 from "./artist.vue?vue&type=style&index=0&id=559c4608&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c4608",
  null
  
)

export default component.exports